// import { lazy, Suspense } from 'react';

// import { Outlet } from 'react-router-dom';
// // auth
// import { AuthGuard } from 'src/auth/guard';
// // layouts
// import DashboardLayout from 'src/layouts/dashboard';
// // components
// import { LoadingScreen } from 'src/components/loading-screen';
// import ProtectedRoute from './protectedRoute';

// // import { chipClasses } from '@mui/material';

// // import { element } from 'prop-types';

// // ----------------------------------------------------------------------

// // dashboard
// const IndexPage = lazy(() => import('src/pages/dashboard/one'));
// const SuperAdminPage = lazy(() => import('src/pages/dashboard/super'));
// const AdminPage = lazy(() => import('src/pages/dashboard/admin'));

// const TrainerPage = lazy(() => import('src/pages/dashboard/trainer'));
// const CounsellorPage = lazy(() => import('src/pages/dashboard/counsellor'));
// // user
// const UserManagement = lazy(() => import('src/pages/user/user'));
// const UserPassword = lazy(() => import('src/pages/user/userpassword'));
// const ProfileManagement = lazy(() => import('src/pages/user/profile'));
// // student
// const StudentManagement = lazy(() => import('src/pages/students/students'));
// const RegistraitionManagement = lazy(() => import('src/pages/students/register'));
// const StudentProfile = lazy(() => import('src/pages/students/studentprofile'));
// const EnquiryManagement = lazy(() => import('src/pages/students/enquiry'));
// const EnquiryAdd = lazy(() => import('src/pages/students/enquiryadd'));
// const EnquiryProfile = lazy(() => import('src/pages/students/enquiryprofile'));
// const Register = lazy(() => import('src/pages/students/registeradd'));
// const RegisterProfile = lazy(() => import('src/pages/students/registerprofile'));
// const RegisterAdd = lazy(() => import('src/pages/students/registeradd'));
// const UpdateDoc = lazy(()=> import('src/pages/students/updatedoc'))
// // const StudentsViewManagement = lazy(() => import('src/pages/students/studentview'));
// const StudentAssignmentManagement = lazy(() => import('src/pages/students/assign'));
// const UpateProfileManagement = lazy(() => import('src/pages/students/updateprofile'));

// // trainer
// const TrainerManagement = lazy(() => import('src/pages/trainer/trainer'));
// const TrainerProfile = lazy(() => import('src/pages/trainer/trainerprofile'));
// const StudentAttendance = lazy(() => import('src/pages/attendance/studentAtten'));
// // Resume
// const Resume = lazy(() => import('src/pages/resume/resume'));
// const ResumeManagement = lazy(() => import('src/pages/resume/studentdetail'));
// const ResumeBatch = lazy(() => import('src/pages/resume/studentist'));
// // Course
// const CourseManagement = lazy(() => import('src/pages/course/course'));
// const BatchChangeManagement = lazy(()=> import("src/pages/updatebatch/updatebatch"))
// // Subject
// const SubjectManagement = lazy(() => import('src/pages/subjects/subjects'));
// const SubjectAdd = lazy(() => import('src/pages/subjects/subjectAdd'));

// // Batchs
// const BatchManagement = lazy(() => import('src/pages/batchs/batches'));
// const ScheduleManagement = lazy(() => import('src/pages/batchs/schedule'));
// const DurationMAnagement = lazy(() => import('src/pages/batchs/duration'));

// // Category
// const CategoryManagement = lazy(() => import('src/pages/category/category'));
// const AnnouncementManagement = lazy(() => import('src/pages/announcement/announcement'));
// const JobPostManagement = lazy(()=> import("src/pages/jobpost/jobpost"));
// const HolidayMangement = lazy(() => import('src/pages/announcement/holiday'));
// const ReportMangement = lazy(() => import('src/pages/announcement/attendancereport'));
// const PerfomanceMangement = lazy(() => import('src/pages/announcement/performance'));
// const StudentPerfomanceMangement = lazy(() => import('src/pages/announcement/perfoermancepage'));

// const AttendanceManagement = lazy(() => import('src/pages/announcement/dailyattendance'));
// const ViewAttendance = lazy(() => import('src/pages/announcement/viewatten'));
// const TrainerAnnounce = lazy(() => import('src/pages/announcement/trainerannouce'));
// const StudentAnnounce = lazy(() => import('src/pages/announcement/studentanounce'));
// // Assignment
// // const AssignmentManagement = lazy(() => import('src/pages/assignment/assignment'));
// const TrainerAssignment = lazy(() => import('src/pages/assignment/trainerAssignment'));
// const CheckAssignment = lazy(() => import('src/pages/assignment/check'));
// const MockManagement = lazy(() => import('src/pages/trainer/mock'));
// const MockReviewManagement = lazy(() => import('src/pages/trainer/mocketails'));
// // Course Mode
// const CourseModeManagement = lazy(() => import('src/pages/course_mode/coursemode'));
// const EligibleStudentManagement = lazy(() => import('src/pages/students/eligible'));
// const PlacedStudentManagement = lazy(() => import('src/pages/students/placed'));
// const PlacedReviewManagement = lazy(() => import('src/pages/students/review'));
// const EnrollmentReportManagement = lazy(() => import('src/pages/announcement/enrollmentreport'));
// const PaymentReportManagement = lazy(() => import('src/pages/announcement/paymentreport'));

// // Due Fee
// const Due = lazy(() => import('src/pages/due/due'));
// const Paid = lazy(() => import('src/pages/paid/paid'));
// const Outstanding = lazy(() => import('src/pages/due/out'));
// // Status
// const StatusManagement = lazy(() => import('src/pages/status/status'));

// // Task
// const TaskManagement = lazy(() => import('src/pages/task/task'));
// const AdminTaskManagement = lazy(() => import('src/pages/tasks/admintask'));
// const AdminDelegated = lazy(() => import('src/pages/tasks/admindele'));

// // Feeset
// const FeeSetManagement = lazy(() => import('src/pages/setfee/setfee'));

// // Counsellors
// const CounsellorsManagement = lazy(() => import('src/pages/counsellors/counsellors'));

// // Payment Mode
// const PaymentModeManagement = lazy(() => import('src/pages/paymentmodes/paymentmodes'));
// const FeeManagement = lazy(() => import('src/pages/feetype/feetype'));
// const CompanyManagement = lazy(() => import('src/pages/company/company'));

// // Payment Bank
// const PaymentBankManagement = lazy(() => import('src/pages/paymentbanks/paymentbanks'));
// const PermissionManagement = lazy(() => import('src/pages/user/permission'));
// const RoleManagement = lazy(() => import('src/pages/user/role'));
// // Leds
// const LeadManagement = lazy(() => import('src/pages/leads/leads'));
// // How Did You know
// const HowDidYouKnowManagement = lazy(() => import('src/pages/howdidyouknow/howdidyouknow'));

// // Work Experience
// const WorkExperienceManagement = lazy(() => import('src/pages/workexperience/workexperience'));

// // // ----------------------------------------------------------------------

// export const dashboardRoutes = [
//   {
//     path: 'dashboard',
//     element: (
//       <AuthGuard>
//         <DashboardLayout style={{ bgcolor: '#f5f5f5' }}>
//           <Suspense fallback={<LoadingScreen />}>
//             <Outlet />
//           </Suspense>
//         </DashboardLayout>
//       </AuthGuard>
//     ),
//     children: [
//       {
//         element: (
//           <ProtectedRoute>
//             <IndexPage />
//           </ProtectedRoute>
//         ),
//         index: true,
//       },

//       {
//         path: 'superadmin',
//         children: [
//           {
//             element: (
//               <ProtectedRoute allowedRoles={[1]}>
//                 <SuperAdminPage />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'admindashboard',
//         children: [
//           {
//             element: (
//               <ProtectedRoute allowedRoles={[3]}>
//                 <AdminPage />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       // {
//       //   path: 'permission',
//       //   children: [
//       //     {
//       //       element: (
//       //         <ProtectedRoute title='permission'>
//       //           <PermissionManagement />
//       //         </ProtectedRoute>
//       //       ),
//       //       index: true,
//       //     },
//       //   ],
//       // },
//       {
//         path: 'role',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="roles.List">
//                 <RoleManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'trainerdashboard',
//         children: [
//           {
//             element: (
//               <ProtectedRoute allowedRoles={[4]}>
//                 <TrainerPage />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//        {
//         path: 'updatedocument',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="studentprofile.UpdateDocument" >
//                 <UpdateDoc />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'trainer-assignment',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="assignments.TrainerView">
//                 <TrainerAssignment />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'check-assignments',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="assignments.CheckAssignments">
//                 <CheckAssignment />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'counsellordashboard',
//         children: [
//           {
//             element: (
//               <ProtectedRoute allowedRoles={[2]}>
//                 <CounsellorPage />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },

//       {
//         path: 'user',
//         children: [
//           {
//             index: true,
//             element: (
//               <ProtectedRoute title="users.List">
//                 <UserManagement />
//               </ProtectedRoute>
//             ),
//             // index: true,
//           },
//           // {
//           //   path: 'profile',
//           //   element: (
//           //     <ProtectedRoute title='user.profile'>
//           //       <ProfileManagement />
//           //     </ProtectedRoute>
//           //   ),
//           //   index: true,
//           // },
//         ],
//       },
//       {
//         path: 'students',
//         children: [
//           {
//             index: true,
//             element: (
//               <ProtectedRoute title="students.List">
//                 <StudentManagement />
//               </ProtectedRoute>
//             ),
//           },
//           {
//             path: 'profile',
//             element: (
//               <ProtectedRoute title="students.Profile">
//                 <StudentProfile />
//               </ProtectedRoute>
//             ),
//           },

//           {
//             path: 'enquiryprofile',
//             element: (
//               <ProtectedRoute title="enquiry.Profile">
//                 <EnquiryProfile />
//               </ProtectedRoute>
//             ),
//           },
//           {
//             path: 'enquiryadd',
//             element: (
//               <ProtectedRoute title="enquiry.Add">
//                 <EnquiryAdd />
//               </ProtectedRoute>
//             ),
//           },

//           {
//             path: 'register',
//             element: (
//               <ProtectedRoute title="registration.List">
//                 <Register />
//               </ProtectedRoute>
//             ),
//           },
//           {
//             path: 'registerprofile',
//             element: (
//               <ProtectedRoute title="registration.Profile">
//                 <RegisterProfile />
//               </ProtectedRoute>
//             ),
//           },
//           {
//             path: 'registeradd',
//             element: (
//               <ProtectedRoute title="registration.Add">
//                 <RegisterAdd />
//               </ProtectedRoute>
//             ),
//           },
//         ],
//       },
//       {
//         path: 'upatepassword',
//         element: (
//           <ProtectedRoute title="users.Password">
//             <UserPassword />
//           </ProtectedRoute>
//         ),
//       },
//       {
//         path: 'upateProfile',
//         element: (
//           <ProtectedRoute title="students.Edit">
//             <UpateProfileManagement />
//           </ProtectedRoute>
//         ),
//       },
//       // {
//       //   path: 'timesheet',
//       //   children: [
//       //     {
//       //       element: (
//       //         <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
//       //           <TaskManagement />
//       //         </ProtectedRoute>
//       //       ),
//       //       index: true,
//       //     },
//       //   ],
//       // },
//       {
//         path: 'task',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="dailytask.List">
//                 <AdminTaskManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'update-batch',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="updatebatch.List">
//                 <BatchChangeManagement/>
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'delegated',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="delegatedtask.List">
//                 <AdminDelegated />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'announcement',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="announcements.List">
//                 <AnnouncementManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'jobpost',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="jobPost.List">
//                 <JobPostManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'holiday',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="announcements.Holiday">
//                 <HolidayMangement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'reports',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="reports.List">
//                 <ReportMangement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'reports-enrollment',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="reports.Enrollment">
//                 <EnrollmentReportManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'reports-performance',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="reports.Performance">
//                 <PerfomanceMangement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'reports-performanceview',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="reports.Performance">
//                 <StudentPerfomanceMangement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'reports-payment',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="reports.Payment">
//                 <PaymentReportManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'student-attendance',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="AttendanceDetails">
//                 <AttendanceManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'studentattendanceview',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="AttendanceDetails">
//                 <ViewAttendance />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'trainer-announcement',
//         children: [
//           {
//             element: (
//               <ProtectedRoute allowedRoles={[4, 5]}>
//                 <TrainerAnnounce />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'course',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="courses.List">
//                 <CourseManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'placed-students',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="placed.List">
//                 <PlacedStudentManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'placed-review',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="placed.Review">
//                 <PlacedReviewManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'lead',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="crm.AllLeads">
//                 <LeadManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'mock',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="trainerprofile.Mock">
//                 <MockManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'mockdetails',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="mockdetails.List">
//                 <MockReviewManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'batchs',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="batches.List">
//                 <BatchManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       // {
//       //   path: 'studentview',
//       //   children: [
//       //     {
//       //       element: (
//       //         <ProtectedRoute title="students.Profile">
//       //           <StudentsViewManagement />
//       //         </ProtectedRoute>
//       //       ),
//       //       index: true,
//       //     },
//       //     {
//       //       path: 'studentassign',
//       //       element: (
//       //         <ProtectedRoute title="assignments.StudentView">
//       //           <StudentAssignmentManagement />
//       //         </ProtectedRoute>
//       //       ),
//       //     },
//       //   ],
//       // },
//       {
//         path: 'studentassign',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="assignments.StudentView">
//                 <StudentAssignmentManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       // {
//       //       path: 'studentassign',
//       //       element: (
//       //         <ProtectedRoute title="assignments.StudentView">
//       //           <StudentAssignmentManagement />
//       //         </ProtectedRoute>
//       //       ),
//       //     },
//       {
//         path: 'subjects',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="subjects.List">
//                 <SubjectManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//           {
//             path: 'subjectadd',
//             element: (
//               <ProtectedRoute title="subjects.Add">
//                 <SubjectAdd />
//               </ProtectedRoute>
//             ),
//           },
//         ],
//       },

//       {
//         path: 'schedule',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="schedule.List">
//                 <ScheduleManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'setFee',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="feestructure.List">
//                 <FeeSetManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'due',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="duefee.List">
//                 <Due />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'outstanding',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="outstandingfee.List">
//                 <Outstanding />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'fee',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="paidfee.List">
//                 <Paid />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'trainer',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="trainers.List">
//                 <TrainerManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//           {
//             path: 'profile',
//             element: (
//               <ProtectedRoute title="trainerprofile.Profile">
//                 <TrainerProfile />
//               </ProtectedRoute>
//             ),
//           },
//         ],
//       },
//       // {
//       //   path: 'duration',
//       //   children: [
//       //     {
//       //       element: (
//       //         <ProtectedRoute title='duration'>
//       //           <DurationMAnagement />
//       //         </ProtectedRoute>
//       //       ),
//       //       index: true,
//       //     },
//       //   ],
//       // },
//       {
//         path: 'internal-hr',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="resume.List">
//                 <Resume />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'student-batch',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="resume.Update">
//                 <ResumeBatch />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'student-update',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="resume.Update">
//                 <ResumeManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'category',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="category.List">
//                 <CategoryManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'course-mode',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="coursemode.List">
//                 <CourseModeManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       // {
//       //   path: 'status',
//       //   children: [
//       //     {
//       //       element: (
//       //         <ProtectedRoute title='status'>
//       //           <StatusManagement />
//       //         </ProtectedRoute>
//       //       ),
//       //       index: true,
//       //     },
//       //   ],
//       // },
//       // {
//       //   path: 'counsellor',
//       //   children: [
//       //     {
//       //       element: (
//       //         <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
//       //           <CounsellorsManagement />
//       //         </ProtectedRoute>
//       //       ),
//       //       index: true,
//       //     },
//       //   ],
//       // },
//       // {
//       //   path: 'payment-installment',
//       //   children: [
//       //     {
//       //       element: (
//       //         <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
//       //           <FeeManagement />
//       //         </ProtectedRoute>
//       //       ),
//       //       index: true,
//       //     },
//       //   ],
//       // },

//       {
//         path: 'payment-banks',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="banks.List">
//                 <PaymentBankManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'payment-modes',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="paymentmode.List">
//                 <PaymentModeManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'about-us',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="aboutus.List">
//                 <HowDidYouKnowManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       // {
//       //   path: 'work-experience',
//       //   children: [
//       //     {
//       //       element: (
//       //         <ProtectedRoute title='workexperience.list'>
//       //           <WorkExperienceManagement />
//       //         </ProtectedRoute>
//       //       ),
//       //       index: true,
//       //     },
//       //   ],
//       // },
//       {
//         path: 'company',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="company.List">
//                 <CompanyManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'enquiry',
//         children: [
//           {
//             index: true,
//             element: (
//               <ProtectedRoute title="enquiry.List">
//                 <EnquiryManagement />
//               </ProtectedRoute>
//             ),
//           },
//         ],
//       },
//       {
//         path: 'interview',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="interview.List">
//                 <EligibleStudentManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'registration',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="registration.List">
//                 <RegistraitionManagement />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'notifications',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="announcements.Notification">
//                 <StudentAnnounce />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//       {
//         path: 'attendance-profile',
//         children: [
//           {
//             element: (
//               <ProtectedRoute title="studentprofile.Attendance">
//                 <StudentAttendance />
//               </ProtectedRoute>
//             ),
//             index: true,
//           },
//         ],
//       },
//     ],
//   },
//   {
//     path: 'enquiryform',
//     element: <EnquiryAdd />,
//   },
//    {
//     path: 'registrationform',
//     element: <RegisterAdd />,
//   },
// ];
import { lazy, Suspense } from 'react';

import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import ProtectedRoute from './protectedRoute';

// import { chipClasses } from '@mui/material';

// import { element } from 'prop-types';

// ----------------------------------------------------------------------

// dashboard
const IndexPage = lazy(() => import('src/pages/dashboard/one'));
const SuperAdminPage = lazy(() => import('src/pages/dashboard/super'));
const AdminPage = lazy(() => import('src/pages/dashboard/admin'));
const TrainerPage = lazy(() => import('src/pages/dashboard/trainer'));
const CounsellorPage = lazy(() => import('src/pages/dashboard/counsellor'));
// user
const UserManagement = lazy(() => import('src/pages/user/user'));

const UserPassword = lazy(() => import('src/pages/user/userpassword'));
const ProfileManagement = lazy(() => import('src/pages/user/profile'));
// student
const StudentManagement = lazy(() => import('src/pages/students/students'));
const RegistraitionManagement = lazy(() => import('src/pages/students/register'));
const StudentProfile = lazy(() => import('src/pages/students/studentprofile'));
const EnquiryManagement = lazy(() => import('src/pages/students/enquiry'));
const EnquiryAdd = lazy(() => import('src/pages/students/enquiryadd'));
const EnquiryProfile = lazy(() => import('src/pages/students/enquiryprofile'));
const Register = lazy(() => import('src/pages/students/registeradd'));
const RegisterProfile = lazy(() => import('src/pages/students/registerprofile'));
const RegisterAdd = lazy(() => import('src/pages/students/registeradd'));
const ReceiptManage =lazy(() => import('src/pages/students/receiptpage'));
const ReferManage =lazy(() => import('src/pages/students/referal'));
const UpdateDoc = lazy(() => import('src/pages/students/updatedoc'));
// const StudentsViewManagement = lazy(() => import('src/pages/students/studentview'));
const StudentAssignmentManagement = lazy(() => import('src/pages/students/assign'));
const UpateProfileManagement = lazy(() => import('src/pages/students/updateprofile'));

// reward
const RewardAddManagement = lazy(() => import('src/pages/rewards/rewardbase'));

// trainer
const TrainerManagement = lazy(() => import('src/pages/trainer/trainer'));
const TrainerProfile = lazy(() => import('src/pages/trainer/trainerprofile'));
const StudentAttendance = lazy(() => import('src/pages/announcement/viewatten'));
const MentorMangement = lazy(() => import('src/pages/user/mentor'));
const MentorProfile = lazy(() => import('src/pages/user/mentorprfilr'));
const ApplicationManage = lazy(() => import('src/pages/announcement/application'));

// Resume
const Resume = lazy(() => import('src/pages/resume/resume'));
const ResumeManagement = lazy(() => import('src/pages/resume/studentdetail'));
const ResumeBatch = lazy(() => import('src/pages/resume/studentist'));
// Course
const CourseManagement = lazy(() => import('src/pages/course/course'));
const BatchChangeManagement = lazy(() => import('src/pages/updatebatch/updatebatch'));
// Subject
const SubjectManagement = lazy(() => import('src/pages/subjects/subjects'));
const SubjectAdd = lazy(() => import('src/pages/subjects/subjectAdd'));
const MailsManagement = lazy(() => import('src/pages/subjects/mails'));

// Batchs
const BatchManagement = lazy(() => import('src/pages/batchs/batches'));
const ScheduleManagement = lazy(() => import('src/pages/batchs/schedule'));
const DurationMAnagement = lazy(() => import('src/pages/batchs/duration'));

// Category
const CategoryManagement = lazy(() => import('src/pages/category/category'));
const AnnouncementManagement = lazy(() => import('src/pages/announcement/announcement'));
const JobPostManagement = lazy(() => import('src/pages/jobpost/jobpost'));
const HolidayMangement = lazy(() => import('src/pages/announcement/holiday'));
const DocumentReview = lazy(() => import('src/pages/announcement/docreview'));
const ReportMangement = lazy(() => import('src/pages/announcement/attendancereport'));
const PerfomanceMangement = lazy(() => import('src/pages/announcement/performance'));
const StudentPerfomanceMangement = lazy(() => import('src/pages/announcement/perfoermancepage'));

const AttendanceManagement = lazy(() => import('src/pages/announcement/dailyattendance'));
const ViewAttendance = lazy(() => import('src/pages/announcement/viewatten'));
const TrainerAnnounce = lazy(() => import('src/pages/announcement/trainerannouce'));
const StudentAnnounce = lazy(() => import('src/pages/announcement/studentanounce'));
// Assignment
// const AssignmentManagement = lazy(() => import('src/pages/assignment/assignment'));
const TrainerAssignment = lazy(() => import('src/pages/assignment/trainerAssignment'));
const CheckAssignment = lazy(() => import('src/pages/assignment/check'));
const MockManagement = lazy(() => import('src/pages/trainer/mock'));
const MockReviewManagement = lazy(() => import('src/pages/trainer/mocketails'));
// Course Mode
const CourseModeManagement = lazy(() => import('src/pages/course_mode/coursemode'));
const EligibleStudentManagement = lazy(() => import('src/pages/students/eligible'));
const PlacedStudentManagement = lazy(() => import('src/pages/students/placed'));
const PlacedReviewManagement = lazy(() => import('src/pages/students/review'));
const EnrollmentReportManagement = lazy(() => import('src/pages/announcement/enrollmentreport'));
const PaymentReportManagement = lazy(() => import('src/pages/announcement/paymentreport'));

// Due Fee
const Due = lazy(() => import('src/pages/due/due'));
const Paid = lazy(() => import('src/pages/paid/paid'));
const Outstanding = lazy(() => import('src/pages/due/out'));
// Status
const StatusManagement = lazy(() => import('src/pages/status/status'));

// Task
const TaskManagement = lazy(() => import('src/pages/task/task'));
const AdminTaskManagement = lazy(() => import('src/pages/tasks/admintask'));
const AdminDelegated = lazy(() => import('src/pages/tasks/admindele'));

// Feeset
const FeeSetManagement = lazy(() => import('src/pages/setfee/setfee'));
const HelpDeskManagement = lazy(() => import('src/pages/helpdesk/helpdesk'));
const Pages  = lazy(() => import('src/pages/user/pages'));

// Counsellors
const CounsellorsManagement = lazy(() => import('src/pages/counsellors/counsellors'));
const ZoomManagement = lazy(() => import('src/pages/zoomacc/zoomacc'));
const ZoomDetailsManagement = lazy(() => import('src/pages/zoomacc/zoom_details'));
// Payment Mode
const PaymentModeManagement = lazy(() => import('src/pages/paymentmodes/paymentmodes'));
const FeeManagement = lazy(() => import('src/pages/feetype/feetype'));
const CompanyManagement = lazy(() => import('src/pages/company/company'));
const QAManagement = lazy(() => import('src/pages/company/qanda'));
const PreferedLocationManagement = lazy(() => import('src/pages/company/preferdlocation'));

// Payment Bank
const PaymentBankManagement = lazy(() => import('src/pages/paymentbanks/paymentbanks'));
const PermissionManagement = lazy(() => import('src/pages/user/permission'));
const RoleManagement = lazy(() => import('src/pages/user/role'));
// Leds
const LeadManagement = lazy(() => import('src/pages/leads/leads'));
// How Did You know
const HowDidYouKnowManagement = lazy(() => import('src/pages/howdidyouknow/howdidyouknow'));

// Work Experience
const WorkExperienceManagement = lazy(() => import('src/pages/workexperience/workexperience'));

// // ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout style={{ bgcolor: '#f5f5f5' }}>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        element: (
          <ProtectedRoute>
            <IndexPage />
          </ProtectedRoute>
        ),
        index: true,
      },

      {
        path: 'superadmin',
        children: [
          {
            element: (
              <ProtectedRoute allowedRoles={[1]}>
                <SuperAdminPage />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'admindashboard',
        children: [
          {
            element: (
              <ProtectedRoute allowedRoles={[3]}>
                <AdminPage />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      // {
      //   path: 'permission',
      //   children: [
      //     {
      //       element: (
      //         <ProtectedRoute title='permission'>
      //           <PermissionManagement />
      //         </ProtectedRoute>
      //       ),
      //       index: true,
      //     },
      //   ],
      // },
      {
        path: 'role',
        children: [
          {
            element: (
              <ProtectedRoute title="roles.List">
                <RoleManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'trainerdashboard',
        children: [
          {
            element: (
              <ProtectedRoute allowedRoles={[4]}>
                <TrainerPage />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'updatedocument',
        children: [
          {
            element: (
              <ProtectedRoute title="studentprofile.UpdateDocument">
                <UpdateDoc />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'trainer-assignment',
        children: [
          {
            element: (
              <ProtectedRoute title="assignments.TrainerView">
                <TrainerAssignment />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'check-assignments',
        children: [
          {
            element: (
              <ProtectedRoute title="assignments.CheckAssignments">
                <CheckAssignment />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'applications',
        children: [
          {
            element: (
              <ProtectedRoute title="applications.List">
                <ApplicationManage />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'counsellordashboard',
        children: [
          {
            element: (
              <ProtectedRoute allowedRoles={[2]}>
                <CounsellorPage />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },

      {
        path: 'user',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute title="users.List">
                <UserManagement />
              </ProtectedRoute>
            ),
            // index: true,
          },
          // {
          //   path: 'profile',
          //   element: (
          //     <ProtectedRoute title='user.profile'>
          //       <ProfileManagement />
          //     </ProtectedRoute>
          //   ),
          //   index: true,
          // },
        ],
      },
      {
        path: 'students',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute title="students.List">
                <StudentManagement />
              </ProtectedRoute>
            ),
          },
          {
            path: 'profile',
            element: (
              <ProtectedRoute title="students.Profile">
                <StudentProfile />
              </ProtectedRoute>
            ),
          },

          {
            path: 'enquiryprofile',
            element: (
              <ProtectedRoute title="enquiry.Profile">
                <EnquiryProfile />
              </ProtectedRoute>
            ),
          },
          {
            path: 'enquiryadd',
            element: (
              <ProtectedRoute title="enquiry.Add">
                <EnquiryAdd />
              </ProtectedRoute>
            ),
          },

          {
            path: 'register',
            element: (
              <ProtectedRoute title="registration.List">
                <Register />
              </ProtectedRoute>
            ),
          },
          {
            path: 'registerprofile',
            element: (
              <ProtectedRoute title="registration.Profile">
                <RegisterProfile />
              </ProtectedRoute>
            ),
          },
          {
            path: 'registeradd',
            element: (
              <ProtectedRoute title="registration.Add">
                <RegisterAdd />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'upatepassword',
        element: (
          <ProtectedRoute title="users.Password">
            <UserPassword />
          </ProtectedRoute>
        ),
      },
      {
        path: 'upateProfile',
        element: (
          <ProtectedRoute title="students.Edit">
            <UpateProfileManagement />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: 'timesheet',
      //   children: [
      //     {
      //       element: (
      //         <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
      //           <TaskManagement />
      //         </ProtectedRoute>
      //       ),
      //       index: true,
      //     },
      //   ],
      // },
      {
        path: 'task',
        children: [
          {
            element: (
              <ProtectedRoute title="dailytask.List">
                <AdminTaskManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'update-batch',
        children: [
          {
            element: (
              <ProtectedRoute title="updatebatch.List">
                <BatchChangeManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'delegated',
        children: [
          {
            element: (
              <ProtectedRoute title="delegatedtask.List">
                <AdminDelegated />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'announcement',
        children: [
          {
            element: (
              <ProtectedRoute title="announcements.List">
                <AnnouncementManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'jobpost',
        children: [
          {
            element: (
              <ProtectedRoute title="jobPost.List">
                <JobPostManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'holiday',
        children: [
          {
            element: (
              <ProtectedRoute title="announcements.Holiday">
                <HolidayMangement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'reports',
        children: [
          {
            element: (
              <ProtectedRoute title="reports.List">
                <ReportMangement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'reports-enrollment',
        children: [
          {
            element: (
              <ProtectedRoute title="reports.Enrollment">
                <EnrollmentReportManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'reports-review',
        children: [
          {
            element: (
              <ProtectedRoute title="reports.DocReview">
                <DocumentReview />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'reports-performance',
        children: [
          {
            element: (
              <ProtectedRoute title="reports.Performance">
                <PerfomanceMangement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'reports-performanceview',
        children: [
          {
            element: (
              <ProtectedRoute title="reports.Performance">
                <StudentPerfomanceMangement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'reports-payment',
        children: [
          {
            element: (
              <ProtectedRoute title="reports.Payment">
                <PaymentReportManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'student-attendance',
        children: [
          {
            element: (
              <ProtectedRoute title="AttendanceDetails">
                <AttendanceManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      
      {
        path: 'helpdesk',
        children: [
          {
            element: (
              <ProtectedRoute title="helpdesk.List">
                <HelpDeskManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'studentattendanceview',
        children: [
          {
            element: (
              <ProtectedRoute title="AttendanceDetails">
                <ViewAttendance />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'trainer-announcement',
        children: [
          {
            element: (
              <ProtectedRoute allowedRoles={[4, 5]}>
                <TrainerAnnounce />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'course',
        children: [
          {
            element: (
              <ProtectedRoute title="courses.List">
                <CourseManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'placed-students',
        children: [
          {
            element: (
              <ProtectedRoute title="placed.List">
                <PlacedStudentManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'placed-review',
        children: [
          {
            element: (
              <ProtectedRoute title="placed.Review">
                <PlacedReviewManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'lead',
        children: [
          {
            element: (
              <ProtectedRoute title="crm.AllLeads">
                <LeadManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
       {
        path: 'pages',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute title="legalPages.List">
                <Pages/>
              </ProtectedRoute>
            ),
           
          },
         
        ],
      },
      {
        path: 'mock',
        children: [
          {
            element: (
              <ProtectedRoute title="trainerprofile.Mock">
                <MockManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'mockdetails',
        children: [
          {
            element: (
              <ProtectedRoute title="mockdetails.List">
                <MockReviewManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'batchs',
        children: [
          {
            element: (
              <ProtectedRoute title="batches.List">
                <BatchManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      // {
      //   path: 'studentview',
      //   children: [
      //     {
      //       element: (
      //         <ProtectedRoute title="students.Profile">
      //           <StudentsViewManagement />
      //         </ProtectedRoute>
      //       ),
      //       index: true,
      //     },
      //     {
      //       path: 'studentassign',
      //       element: (
      //         <ProtectedRoute title="assignments.StudentView">
      //           <StudentAssignmentManagement />
      //         </ProtectedRoute>
      //       ),
      //     },
      //   ],
      // },
      {
        path: 'studentassign',
        children: [
          {
            element: (
              <ProtectedRoute title="assignments.StudentView">
                <StudentAssignmentManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      // {
      //       path: 'studentassign',
      //       element: (
      //         <ProtectedRoute title="assignments.StudentView">
      //           <StudentAssignmentManagement />
      //         </ProtectedRoute>
      //       ),
      //     },
      {
        path: 'subjects',
        children: [
          {
            element: (
              <ProtectedRoute title="subjects.List">
                <SubjectManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
          {
            path: 'subjectadd',
            element: (
              <ProtectedRoute title="subjects.Add">
                <SubjectAdd />
              </ProtectedRoute>
            ),
          },
        ],
      },
{
        path: 'mails',
        children: [
          {
            element: (
              <ProtectedRoute title="SendMail.Add">
                <MailsManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'schedule',
        children: [
          {
            element: (
              <ProtectedRoute title="schedule.List">
                <ScheduleManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'setFee',
        children: [
          {
            element: (
              <ProtectedRoute title="feestructure.List">
                <FeeSetManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'due',
        children: [
          {
            element: (
              <ProtectedRoute title="duefee.List">
                <Due />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'outstanding',
        children: [
          {
            element: (
              <ProtectedRoute title="outstandingfee.List">
                <Outstanding />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'fee',
        children: [
          {
            element: (
              <ProtectedRoute title="paidfee.List">
                <Paid />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
     
      {
        path: 'trainer',
        children: [
          {
            element: (
              <ProtectedRoute title="trainers.List">
                <TrainerManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
          {
            path: 'profile',
            element: (
              <ProtectedRoute title="trainerprofile.Profile">
                <TrainerProfile />
              </ProtectedRoute>
            ),
          },
        ],
      },
        {
        path: 'mentor',
        children: [
          {
            element: (
              <ProtectedRoute title="mentor.List">
                <MentorMangement />
              </ProtectedRoute>
            ),
            index: true,
          },
          {
            path: 'profile',
            element: (
              <ProtectedRoute title="mentor.Profile">
                <MentorProfile />
              </ProtectedRoute>
            ),
          },
        ],
      },
        
      {
        path: 'reward',
        children: [
          {
            element: (
              <ProtectedRoute title='refer&earn.List'>
               <RewardAddManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'internal-hr',
        children: [
          {
            element: (
              <ProtectedRoute title="resume.List">
                <Resume />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'student-batch',
        children: [
          {
            element: (
              <ProtectedRoute title="resume.Update">
                <ResumeBatch />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'student-update',
        children: [
          {
            element: (
              <ProtectedRoute title="resume.Update">
                <ResumeManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'category',
        children: [
          {
            element: (
              <ProtectedRoute title="category.List">
                <CategoryManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'course-mode',
        children: [
          {
            element: (
              <ProtectedRoute title="coursemode.List">
                <CourseModeManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      // {
      //   path: 'status',
      //   children: [
      //     {
      //       element: (
      //         <ProtectedRoute title='status'>
      //           <StatusManagement />
      //         </ProtectedRoute>
      //       ),
      //       index: true,
      //     },
      //   ],
      // },
      // {
      //   path: 'counsellor',
      //   children: [
      //     {
      //       element: (
      //         <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
      //           <CounsellorsManagement />
      //         </ProtectedRoute>
      //       ),
      //       index: true,
      //     },
      //   ],
      // },
      // {
      //   path: 'payment-installment',
      //   children: [
      //     {
      //       element: (
      //         <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
      //           <FeeManagement />
      //         </ProtectedRoute>
      //       ),
      //       index: true,
      //     },
      //   ],
      // },

      {
        path: 'payment-banks',
        children: [
          {
            element: (
              <ProtectedRoute title="banks.List">
                <PaymentBankManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'payment-modes',
        children: [
          {
            element: (
              <ProtectedRoute title="paymentmode.List">
                <PaymentModeManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      
      {
        path: 'about-us',
        children: [
          {
            element: (
              <ProtectedRoute title="aboutus.List">
                <HowDidYouKnowManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'zoom-accounts',
        children: [
          {
            element: (
              <ProtectedRoute title="zoomAccount.List">
                <ZoomManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'zoom-meets',
        children: [
          {
            element: (
              <ProtectedRoute title="zoom.List">
                <ZoomDetailsManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      // {
      //   path: 'work-experience',
      //   children: [
      //     {
      //       element: (
      //         <ProtectedRoute title='workexperience.list'>
      //           <WorkExperienceManagement />
      //         </ProtectedRoute>
      //       ),
      //       index: true,
      //     },
      //   ],
      // },
      {
        path: 'company',
        children: [
          {
            element: (
              <ProtectedRoute title="company.List">
                <CompanyManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'question_answer',
        children: [
          {
            element: (
              <ProtectedRoute title="q&a.List">
                <QAManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
  path: 'preferred-location',
  children: [
    {
      element: (
        <ProtectedRoute title="preferredLocation.List">
          <PreferedLocationManagement />
        </ProtectedRoute>
      ),
      index: true,
    },
  ],
},

      {
        path: 'enquiry',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute title="enquiry.List">
                <EnquiryManagement />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'interview',
        children: [
          {
            element: (
              <ProtectedRoute title="interview.List">
                <EligibleStudentManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'registration',
        children: [
          {
            element: (
              <ProtectedRoute title="registration.List">
                <RegistraitionManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'notifications',
        children: [
          {
            element: (
              <ProtectedRoute title="announcements.Notification">
                <StudentAnnounce />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'attendance-profile',
        children: [
          {
            element: (
              <ProtectedRoute title="studentprofile.Attendance">
                <AttendanceManagement />
              </ProtectedRoute>
            ),
            index: true,
          },
        ],
      },
    ],
  },
  {
    path: 'enquiryform',
    element: <EnquiryAdd />,
  },
  {
    path: 'registrationform',
    element: <RegisterAdd />,
  },
  {
    path: 'receipt',
    element: <ReceiptManage />,
  },
  {
    path: 'rewardregistrationform',
    element: <ReferManage />,
  },
];
